<template>
  <!-- When on mobile wrap in dialog -->
  <slotted-dialog v-if="isPhoneBool" :title="title" :externaltrigger="dialogtrigger"
    :externalCloseTrigger="dialogclosetrigger">

    <template v-slot:content>
      <template v-if="viewFilterContent">
        <FilterSearch :pk="pk" />
        <slot name="filters-content">
          filters
        </slot>
      </template>

      <slot name="sorting-content" v-if="viewSortContent">
        sorting
      </slot>
    </template>

    <template v-slot:buttons>
      <slot name="buttons" />
    </template>

  </slotted-dialog>

  <!-- When on anything else show normal -->
  <SlottedGrowContainer v-else fluid class="pa-0 relative" style="height: inherit;" :style="styleoverride">
    <!-- border-right: 1px solid rgb(200, 200, 200); -->

    <template v-slot:toolbar-content>
      <slot name="toolbar-content">
        <FilterTabs :pk="pk" :showFilterTab="filterContentSlotPopulated"
          :showSortingTab="sortingContentSlotPopulated" />
      </slot>
    </template>

    <v-progress-linear :indeterminate="!loaded" v-if="!loaded">
    </v-progress-linear>

    <slot>
      <v-container fluid class="pa-0" :key="$route.query[pk + 'resetkey']">

        <template v-if="viewFilterContent">
          <!-- <h3 v-text="'Filters'" class="pa-2" /> -->
          <!-- <FilterSearch class="mt-4 ml-2 mr-3" :limitWidth="false" /> -->
          <slot name="filters-content">
            filters
          </slot>
        </template>

        <slot name="sorting-content" v-if="viewSortContent">
        </slot>
      </v-container>
    </slot>

    <template v-slot:footer-content>
      <slot name="footer-content" />
    </template>

  </SlottedGrowContainer>
</template>


<script>
import FilterQueryMixin from "@/helpers/Mixins/FilterQueryMixin.js";
import FilterTabs from "@/views/layouts/FilterTabs.vue";
import FilterSearch from "@/views/layouts/FilterSearch.vue";
import SlottedDialog from "@/views/layouts/SlottedDialog.vue";
import SlottedGrowContainer from "@/views/layouts/SlottedGrowContainer.vue";

export default {
  name: "FilterPane",
  props: {
    pk: String,
    title: String,
    loaded: {
      default: true,
      type: Boolean,
    },
    styleoverride: String,
  },
  components: {
    FilterTabs,
    FilterSearch,
    SlottedDialog,
    SlottedGrowContainer,
  },
  mixins: [FilterQueryMixin],

  data() {
    return {
    };
  },

  mounted() { },

  methods: {},

  computed: {
    filterContentSlotPopulated() { return !!this.$slots['filters-content']; },
    sortingContentSlotPopulated() { return !!this.$slots['sorting-content']; },

    dialogtrigger() { return this.$store.state.triggerevents.previewTrigger; },
    dialogclosetrigger() { return this.$store.state.triggerevents.previewCloseTrigger; },

    viewFilterContent() { return this.$route.query[this.pk + 'filter'] === "filter"; },
    viewSortContent() { return this.$route.query[this.pk + 'filter'] === "sort"; },
  },

  watch: {},
};
</script>


<style lang="scss" scoped>
.relative {
  position: relative;
}
</style>